import "./App.css";
import "./assets/fonts/Font.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import NaverWCS from "./componant/wcs/NaverWCS";
import TrackPageView from "./componant/wcs/TrackPageView";
import AppContent from "./AppContent";
import { BrowserRouter } from "react-router-dom";
import { atom } from "jotai";
import { Provider } from "jotai";
import { useEffect } from "react";
import { isMobile } from "react-device-detect";
import { postNumbaInsRef } from "./api/auth";
import useRefresh from "./utils/hooks/useRefresh";
import axios from "axios";
import config from "./config";
import { onMessage } from 'firebase/messaging';
// ✅ messagingReady 추가
import { messagingReady } from './firebase';

export const userLoginJotai = atom();
export const headerText = atom("");

function App() {
  const refreshToken = localStorage.getItem("refresh_token");
  const { refreshTimeOut } = useRefresh();

  useEffect(() => {
    const init = async () => {
      if (isMobile && !refreshToken) {
        if ((!refreshToken || refreshToken.trim() === "") && isMobile) {
          try {
            await refresh();
          } catch (error) {
            console.error("Token refresh failed:", error);
          }
        }
      }
      if (isMobile) {
        if (window.ReactNativeWebView) {
          window.addEventListener("message", handleMessage);
        } else {
          document.addEventListener("message", handleMessage);
        }
        sessionStorage.setItem("isMobile", "Y");
        return () => {
          if (window.ReactNativeWebView) {
            window.removeEventListener("message", handleMessage);
          } else {
            document.removeEventListener("message", handleMessage);
          }
        };
      } else {
        sessionStorage.setItem("isMobile", "N");
      }
    };
    init();
  }, [refreshToken]);

  async function refresh() {
    try {
      const response = await axios({
        url: config.API_URL + "/auth/refreshAfterTimeOut",
        data: {},
        method: "post",
        withCredentials: true,
        headers: { Authorization: "" },
      });
      if (response.data.access_token) {
        const { access_token, refresh_token } = response.data;
        localStorage.setItem("access_token", access_token);
        localStorage.setItem("refresh_token", refresh_token);
        navigator("/login");
      }
    } catch (err) {
      console.error("Failed to refresh token", err);
    }
  }

  useEffect(() => {
    sessionStorage.removeItem("q");
    if (document?.referrer) {
      let ref = document?.referrer;
      const queryStringIndex = ref.indexOf("?");
      if (queryStringIndex !== -1) {
        ref = ref.substring(0, queryStringIndex);
        sessionStorage.setItem("ref", ref);
        const queryString = document.referrer.substring(queryStringIndex + 1);
        const params = new URLSearchParams(queryString);
        const queryParam = params.get("query");
        if (queryParam) {
          const decodedQueryParam = decodeURIComponent(queryParam);
          sessionStorage.setItem("ref_keyword", decodedQueryParam);
        }
      } else {
        sessionStorage.setItem("ref", ref);
        sessionStorage.setItem("ref_keyword", "");
      }
    }

    const path = window.location.pathname;
    const regex = /\/q=(.*)/;
    const match = path.match(regex);
    if (match && match.length > 1) {
      sessionStorage.setItem("q", match[1]);
    }

    const queryParams = new URLSearchParams(window.location.search);
    const q = queryParams.get("q");
    if (q) sessionStorage.setItem("q", q);

    insRef();
  }, [document?.referrer]);


  // messagingReady 완료 후 onMessage 등록
  useEffect(() => {
    let unsubscribe = null;

    messagingReady.then((msg) => {
      if (!msg) {
        // WKWebView, 미지원 브라우저 등 → 조용히 무시
        console.log("onMessage 등록 생략 (미지원 환경)");
        return;
      }

      unsubscribe = onMessage(msg, (payload) => {
        // console.log("포그라운드 FCM 수신:", payload);
        const title = payload.notification?.title || payload.data?.title;
        const body = payload.notification?.body || payload.data?.body;
        alert(`${title}\n${body}`);
      });
    });

    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, []);


  function insRef() {
    try {
      postNumbaInsRef({
        referer: sessionStorage.getItem("ref"),
        ref_keyword: sessionStorage.getItem("ref_keyword"),
        q: sessionStorage.getItem("q"),
        isMobile: sessionStorage.getItem("isMobile"),
      });
    } catch (e) {
      console.error(e);
    }
  }

  const handleMessage = (event) => {
    try {
      const { type, data } = JSON.parse(event?.data);
    } catch (err) {
      // ignore
    }
  };

  return (
    <>
      <Provider>
        <BrowserRouter>
          <TrackPageView />
          <AppContent />
        </BrowserRouter>
      </Provider>
    </>
  );
}

export default App;
